/** Vendors considered first-party (not third-party) for model classification. */
export const FIRST_PARTY_VENDORS: ReadonlySet<string> = new Set(['Azure OpenAI', 'OpenAI'])
